import React from 'react'

import { writeFile, readFile } from '@utils/fs-helpers'

import {
  getEntity,
  getHeaderData,
  getFooterData,
  getFaqCategoriesData,
} from '@api/index'

import { default as normalizeHeaderData } from '@models/Header'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeArchiveFAQ } from '@models/ArchiveFaq'
import { default as normalizeFAQ } from '@models/Faq'
import { default as normalizeBreadcrumb } from '@models/Breadcrumb'

import { Col, Container, Row } from '@/atoms/Grid'
import Breadcrumb from '@/molecules/Breadcrumb'
import { ArchiveList, ArchiveSidebar } from '@/organisms'

import Layout from '@/organisms/Layout'

export const getStaticPaths = async () => {
  const faq = await Promise.all(
    [{ entity: 'faq' }].map(({ entity }) => getEntity({ entity }))
  )

  const paths = faq.reduce((acc, { data }) => {
    if (!data) return acc

    const pathData = Array.isArray(data) ? data : [data]
    const paths = pathData.map(({ categories }) => {
      return categories.map(({ slug }) => {
        return {
          params: {
            slug,
          },
        }
      })
    })

    return [...acc, ...paths]
  }, [])

  try {
    const pagesCache = faq.reduce((acc, { data, entity }) => {
      if (!data || data.length === 0) return acc

      const pathData = Array.isArray(data) ? data : [data]
      const paths = pathData.map(({ categories }) => {
        return categories.map(({ slug }) => {
          return {
            slug,
            entity,
          }
        })
      })

      return [...acc, ...paths]
    }, [])

    await writeFile(
      'cache/static-paths-faq.json',
      JSON.stringify(...pagesCache),
      'utf-8'
    )
  } catch (error) {
    console.error('Generate cache file error', error)
  }

  return {
    paths: paths[0],
    fallback: false,
  }
}

export const getStaticProps = async ({ params }) => {
  const cacheFile = await readFile('cache/static-paths-faq.json', 'utf-8')
  const staticPaths = JSON.parse(cacheFile)

  const { slug } = staticPaths.find((path) => {
    const slug = Array.isArray(path.slug) ? path.slug.join('/') : path.slug
    return slug === `${params.slug}`
  })

  const [header, footer, data] = await Promise.all([
    getHeaderData(),
    getFooterData(),
    getFaqCategoriesData(),
  ])

  let faq = null
  data.categories.map((el) => {
    if (el.slug == slug) {
      faq = el
      el.isActive = true
    }
  })
  const normalizedFaq = normalizeFAQ(faq)

  return {
    props: {
      metadata: {
        metaTitle: `${normalizedFaq.name} - Categoria FAQ`,
      },
      breadcrumb: normalizeBreadcrumb([
        {
          role: 'link',
          label: 'FAQ',
          href: '/faq',
        },
        {
          label: normalizedFaq.name,
        },
      ]),
      footer: normalizeFooterData(footer),
      header: normalizeHeaderData(header),
      content: normalizeArchiveFAQ(data),
      list: {
        entity: 'faq',
        type: 'accordion',
        categories: [normalizedFaq],
        backButton: true,
        backButtonLabel: 'Torna a tutte le F.A.Q',
      },
    },
  }
}

const CategoryFAQ = ({
  metadata,
  breadcrumb,
  header,
  footer,
  content,
  list,
}) => {
  return (
    <Layout
      metadata={metadata}
      headerData={header}
      footerData={footer}
      colorScheme='primaryLight'
    >
      <Breadcrumb items={breadcrumb} />
      <Container>
        <Row>
          <Col
            xs={12}
            lg={4}
          >
            <ArchiveSidebar
              {...content.sidebar}
              entity='faq'
            />
          </Col>
          <Col
            xs={12}
            lg={8}
          >
            <ArchiveList {...list} />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default CategoryFAQ
